(function () {
    'use strict';

    angular
        .module('procedureModule')
        .controller('prcResponsibilityModalController', Controller);

    Controller.$inject = ['$scope', '$rootScope', 'procedureService', 'responsibilityService'];

    function Controller($scope, $rootScope, procedureService, responsibilityService) {
        $scope.modalCtxt = {
            existingResponsibilities: null,
            lookupAttributesByID: {},
            participantId: null
        };

        initLookupAttributes();

        // Find Responsibilities
        $scope.findResponsibilities = function () {
            // TODO: Page is marked dirty when search field content is changed preventing selecting the object
            // TODO: We should find the reason why (boxFormDirtyDirective) and properly fix this
            $rootScope.$broadcast('page-is-not-dirty');
            responsibilityService
                .findResponsibilities($scope.selection.title, $scope.modalCtxt.participantId)
                .then(function (responsibilities) {
                    $scope.modalCtxt.existingResponsibilities = responsibilities;

                    checkResponsibilities();
                });
        };

        // Participant Selected
        $scope.participantSelected = function () {
            if ($scope.selection.participant.BusinessUnitID) {
                $scope.selection.busUnitParticipant = $scope.selection.participant;
                $scope.modalCtxt.participantId = $scope.selection.busUnitParticipant.BusinessUnitID;
            } else if ($scope.selection.participant.CommitteeID) {
                $scope.selection.committeeParticipant = $scope.selection.participant;
                $scope.modalCtxt.participantId = $scope.selection.committeeParticipant.CommitteeID;
            } else if ($scope.selection.participant.CorporateRoleID) {
                $scope.selection.corporateRoleParticipant = $scope.selection.participant;
                $scope.modalCtxt.participantId = $scope.selection.corporateRoleParticipant.CorporateRoleID;
            }

            $scope.findResponsibilities();
        };

        function initLookupAttributes() {
            procedureService
                .getAllSectionBlockLookupAttributes()
                .then(function (lookupAttributes) {
                    _.forOwn(lookupAttributes, function (lookupAttribute) {
                        $scope.modalCtxt.lookupAttributesByID[lookupAttribute.LookupAttributeID] = lookupAttribute;
                    });
                });
        }

        function checkResponsibilities() {
            _.each($scope.modalCtxt.existingResponsibilities, function (responsibility) {
                responsibility._isCompatible = isResponsibilityCompatible(responsibility);
            });
        }

        function isResponsibilityCompatible(responsibility) {

            // Business Unit Participant
            if (responsibility.BusinessUnit) {
                return _.findIndex($scope.participants.BusinessUnit, {
                        BusinessUnitID: responsibility.BusinessUnit.BusinessUnitID
                    }) > -1;
            }

            // Committee Participant
            if (responsibility.Committee) {
                return _.findIndex($scope.participants.Committee, {
                        CommitteeID: responsibility.Committee.CommitteeID
                    }) > -1;
            }

            // Corporate Role Participant
            if (responsibility.CorporateRole) {
                return _.findIndex($scope.participants.CorporateRole, {
                        CorporateRoleID: responsibility.CorporateRole.CorporateRoleID
                    }) > -1;
            }

            return false;
        }
    }
})();
